

function Modal({id, file_url, disclaimer}) {
    const icon = cloudIcon;
    console.log(icon);
    return (
        <div className="modal fade" id={id} tabindex="-1" aria-labelledby="modal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body text-center p-2 pt-4 pb-0">
                        <img src={icon} ></img>
                    </div>
                    <div className="modal-body text-center">
                        <p>{disclaimer}</p>
                    </div>
                    <div className="modal-footer border-0">
                        <a className="btn btn-warning m-auto btn-mm-download" href={file_url} download>Download</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Modal
